import { Component } from '@angular/core';

@Component({
  selector: 'zc-timeline-caption',
  templateUrl: './timeline-caption.component.html',
  styleUrls: ['./timeline-caption.component.scss'],
})
export class TimelineCaptionComponent {}
